export const projectspaceHomeUrl = `/projects/:project`;
export const projectspaceSettingsUrl = `/projects/:project/settings`;
export const projectspaceMembersUrl = `/projects/:project/members`;
export const projectspaceDataUrl = `/projects/:project/data`;
export const deltaViewUrl = `/projects/:project/delta-data`;
export const comparisonViewUrl = `/projects=:project/delta-comparison`;
